import { Badge } from '@plush-book/ui';
type BadgeTone = NonNullable<Parameters<typeof Badge>[0]['tone']>;

const map: Record<string, BadgeTone> = {
  Paid: 'admin-blue',
  'Preview Ready': 'admin-violet',
  'Revision Requested': 'admin-red',
  Approved: 'admin-green',
  'Sent to Print': 'admin-neutral',
  Generating: 'admin-amber',
  'Needs Review': 'admin-amber',
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge tone={map[status] ?? 'admin-neutral'} withDot>
      {status}
    </Badge>
  );
}
